import "./assets/scss/style.scss";

import { lazy, useEffect } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import { useEmbeddedHelper } from "./core/navigation/use-embedded-helper";
import { WEB_CONFIG } from "./core/web-config";
import { LandingPage } from "./landing-page";
import { SuspenseShimmerWithUI } from "./suspense";

const AppBootstrap = lazy(() => import("./app-bootstrap"));
const Dashboard = lazy(() => import("./dashboard/dashboard"));
const Hotlink = lazy(() => import("./hotlink/hotlink"));

export function App() {
  const embedded = useEmbeddedHelper();

  useEffect(() => {
    if (embedded.isEmbedded) {
      document.body.setAttribute("data-embed", "true");
    } else {
      document.body.removeAttribute("data-embed");
    }
  }, [embedded.isEmbedded]);

  return (
    <Router>
      <Switch>
        <Route path={"/_hotlink"}>
          <SuspenseShimmerWithUI>
            <AppBootstrap>
              <Hotlink />
            </AppBootstrap>
          </SuspenseShimmerWithUI>
        </Route>
        {WEB_CONFIG.IS_CATCH_ALL_DOMAIN ? (
          <Route path={"/:divisionCode(\\d+)/_hotlink"}>
            <SuspenseShimmerWithUI>
              <AppBootstrap>
                <Hotlink />
              </AppBootstrap>
            </SuspenseShimmerWithUI>
          </Route>
        ) : null}

        {WEB_CONFIG.IS_CATCH_ALL_DOMAIN ? (
          <Route path="/:id([a-zA-Z0-9]{7})">
            <SuspenseShimmerWithUI>
              <AppBootstrap>
                <Dashboard />
              </AppBootstrap>
            </SuspenseShimmerWithUI>
          </Route>
        ) : null}
        {WEB_CONFIG.IS_CATCH_ALL_DOMAIN ? (
          <Route path={"/:divisionCode(\\d+)"}>
            <SuspenseShimmerWithUI>
              <AppBootstrap>
                <Dashboard />
              </AppBootstrap>
            </SuspenseShimmerWithUI>
          </Route>
        ) : (
          <Route>
            <SuspenseShimmerWithUI>
              <AppBootstrap>
                <Dashboard />
              </AppBootstrap>
            </SuspenseShimmerWithUI>
          </Route>
        )}
        {WEB_CONFIG.IS_CATCH_ALL_DOMAIN ? (
          <Route>
            <LandingPage />
          </Route>
        ) : null}
      </Switch>
    </Router>
  );
}
